import React, { useEffect, useRef, useState } from "react";
import "./Preloader.css";

export default function Preloader({ duration = 4000, onFinish }) {
  const videoRef = useRef(null);
  const [slideOut, setSlideOut] = useState(false);

  useEffect(() => {
    if (videoRef.current) videoRef.current.playbackRate = 3;

    const timer = setTimeout(() => setSlideOut(true), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  const handleTransitionEnd = () => {
    if (slideOut && onFinish) onFinish();
  };

  return (
    <div
      className={`preloader ${slideOut ? "slide-up" : ""}`}
      onTransitionEnd={handleTransitionEnd}
    >
      <video
        ref={videoRef}
        className="loader-video"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src="/loadervideo/loader_3.mp4" type="video/mp4" />

      </video>
    </div>
  );
}
